import { render, staticRenderFns } from "./appealManage.vue?vue&type=template&id=6af82c26&scoped=true"
import script from "./appealManage.vue?vue&type=script&lang=js"
export * from "./appealManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af82c26",
  null
  
)

export default component.exports